export const formatPixelsToTimestamp = (ratio: number, pixels: number) => ratio * pixels;
